import React from "react";
import PropTypes from "prop-types";
import Page from "../../components/Page";
import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";

import EmployeeViewForm from "../../components/forms/EmployeeViewForm";
import ScheduleOfEmployee from "../../components/ScheduleOfEmployee";

const EmployeeDetailPage = (props) => (
  <Page enableGoBack title="Medewerker details">
    <CenteredPageContentContainer>
      <PaperContainer title="Gegevens van deze medewerker" isAccordion={true}>
        <EmployeeViewForm email={props.match.params.employee_email} />
      </PaperContainer>
    </CenteredPageContentContainer>

    <CenteredPageContentContainer>
      <PaperContainer title="Planning van deze medewerker">
        <ScheduleOfEmployee
          companyEmail={props.match.params.company_email}
          employeeEmail={props.match.params.employee_email}
        />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

EmployeeDetailPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      company_email: PropTypes.string,
      employee_email: PropTypes.string.isRequired,
    }),
  }),
};

export default EmployeeDetailPage;



// WEBPACK FOOTER //
// ./src/pages/Employee/EmployeeDetailPage.js